import ComingSoon from "./coming-soon.component";

export default ComingSoon;
